


const About = () => {
    console.log("about");
    return (
        <section className="about">
            <div className="container">
                <div className="about__body">
                    <p className="margin-top-zero"><span className="jake">Jake Morris</span> is a drummer, vocalist and multi-instrumentalist living in Portland, OR.</p>

                    <p>Jake began playing drums at the age of 9 and has been a working drummer for over 30 years. Since 2011 he has been the drummer for <a target="_blank" rel="noopener noreferrer" href="http://stephenmalkmus.com/">Stephen Malkmus and The Jicks</a>.</p>

                    <p>Along with Stephen Malkmus and The Jicks, Jake also writes, records and performs with his own band <a target="_blank" rel="noopener noreferrer" href="https://streetnights.bandcamp.com/music">Street Nights</a> and instrumental “micro-prog” trio <a target="_blank" rel="noopener noreferrer"href="https://blesstchest.bandcamp.com/">Blesst Chest.</a> </p>

                    <p style={{marginBottom: "42px"}}>Jake has toured all over the world with various bands since 2001 including:  <a target="_blank" rel="noopener noreferrer" href="https://open.spotify.com/artist/5gvPjkbnAEFeDYUhHbFqTx">The Joggers</a>,  <a target="_blank" rel="noopener noreferrer"href="https://open.spotify.com/artist/2Jj04JcXjjnE99c4225LHF">French Kicks</a>, <a target="_blank" rel="noopener noreferrer"href="https://grails.bandcamp.com/">Grails</a>, <a target="_blank" href="https://open.spotify.com/artist/1rTxCX0gbH7ULTkSmCYqmx"rel="noopener noreferrer">The Shaky Hands</a> and <a target="_blank" rel="noopener noreferrer" href="https://oneelevenheavy.com/">One Eleven Heavy</a>. He has appeared on The Late Show With David Letterman, Late Night with Jimmy Fallon, Last Call with Carson Daly and has been featured in                     <a target="_blank"rel="noopener noreferrer"  href="https://www.moderndrummer.com/article-tags/jake-morris/">Modern Drummer Magazine</a></p>


                    <p style={{marginTop: "42px"}}>Jake proudly plays <a target="_blank" rel="noopener noreferrer" href="https://www.candcdrumsusa.com/artists-li-ri">C and C Custom Drums</a></p>
                </div>

            </div>

        </section>
    )
}

export default About;